export default __webpack_public_path__ + "static/media/ArrowDown.feb9ec1f.svg";